import { render, staticRenderFns } from "./messTeam.vue?vue&type=template&id=244273f5&scoped=true&"
import script from "./messTeam.vue?vue&type=script&lang=js&"
export * from "./messTeam.vue?vue&type=script&lang=js&"
import style0 from "./messTeam.vue?vue&type=style&index=0&id=244273f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244273f5",
  null
  
)

export default component.exports